module.exports = __webpack_public_path__ + "98262585.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlassian/brand-logos/dist/products/confluence-white.svg
// module id = 214
// module chunks = 0